<template>

  <div class="container-fluid text-left container-fluid-server" style="margin-top:20px">
    <div class="row-fluid">

      <div class="span12">
        <h4>生活服务</h4>
        <div class="container-fluid container-fluid-server">
          <div class="row">
            <div class="col-6 t_10" v-for="(item,index) in list1" :key="index"
              @click="$router.push({name:'server_user_shows',query:{id:item.ojb_id}})" v-show="index<list_t1">
              <div class="row t_10_t" style="margin-right: 0px;">
                <div class="col-3"
                  style="display: flex; flex-direction: column;justify-content: center;text-align: center;">
                  <img src="https://img.hsnms.com/20210808/1628354863.png" width="30" height="30" />
                </div>
                <div class="col-9">
                  <h5 style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{item.entry_name}}</h5>
                  <h6 class="help-block">{{item.entry_community?item.entry_community:'暂无'}}</h6>
                </div>
              </div>
            </div>

            <!-- <div class="col-6 t_10">
              <div class="row t_10_t">
                <div class="col-3"
                  style="display: flex; flex-direction: column;justify-content: center;text-align: center;">
                  <img src="https://img.hsnms.com/20210808/1628354863.png" width="30" height="30" />
                </div>
                <div class="col-9">
                  <h5>志愿者查询</h5>
                  <h6 class="help-block">志愿者自动交流</h6>
                </div>
              </div>
            </div> -->

          </div>
        </div>
        <button v-if="moreShowBoolen" @click="moreShow" class="btn2"
          style="display:block;margin:15px auto 0;outline: none;outline: none;">更多选项</button>
        <div class="col-12" v-else style="height:15px"></div>
      </div>

      <div class="span12 t_15">
        <h4>文化服务</h4>
        <div class="container-fluid container-fluid-server">
          <div class="row">
            <div class="col-6 t_10" v-for="(item,index) in list2" :key="index"
              @click="$router.push({name:'server_user_shows',query:{id:item.ojb_id}})" v-show="index<list_t2">
              <div class="row t_10_t" style="margin-right: 0px;">
                <div class="col-3"
                  style="display: flex; flex-direction: column;justify-content: center;text-align: center;">
                  <img src="https://img.hsnms.com/20210808/1628354863.png" width="30" height="30" />
                </div>
                <div class="col-9">
                  <h5 style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{item.entry_name}}</h5>
                  <h6 class="help-block">{{item.entry_community?item.entry_community:'暂无'}}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
        <button v-if="moreShowBoolen2" @click="moreShow1" class="btn2"
          style="display:block;margin:15px auto 0;outline: none;outline: none;">更多选项</button>
        <div class="col-12" v-else style="height:15px"></div>
      </div>

      <div class="span12 t_15">
        <h4>帮扶服务</h4>
        <div class="container-fluid container-fluid-server">
          <div class="row">
            <div class="col-6 t_10" v-for="(item,index) in list3" :key="index"
              @click="$router.push({name:'server_user_shows',query:{id:item.ojb_id}})" v-show="index<list_t3">
              <div class="row t_10_t" style="margin-right: 0px;">
                <div class="col-3"
                  style="display: flex; flex-direction: column;justify-content: center;text-align: center;">
                  <img src="https://img.hsnms.com/20210808/1628354863.png" width="30" height="30" />
                </div>
                <div class="col-9">
                  <h5 style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{item.entry_name}}</h5>
                  <h6 class="help-block">{{item.entry_community?item.entry_community:'暂无'}}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
        <button v-if="moreShowBoolen3" @click="moreShow2" class="btn2"
          style="display:block;margin:15px auto 0;outline: none;outline: none;">更多选项</button>
        <div class="col-12" v-else style="height:15px"></div>
        <!-- <div v-else style="text-align:center;margin-top:15px"></div> -->
      </div>

    </div>
    <div id="d_p"></div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      list1: [],
      list1_db_t: 0,
      list2: [],
      list2_db_t: 0,
      list3: [],
      list3_db_t: 0,
      moreShowBoolen: false,
      moreShowBoolen2: false,
      moreShowBoolen3: false,
      nowPage: 1,
      nowPage1: 1,
      nowPage2: 1,
      list_t1: 8,
      list_t2: 8,
      list_t3: 8,
    }
  },
  methods: {
    moreShow () { // 点击查询更多
      console.log("s");
      this.list_t1 += this.list_t1;
      console.log(this.list_t1);
      if (this.list_t1 > this.list1_db_t) {
        this.moreShowBoolen = false
      }
      // this.$api.getAPI('mutual/server/?appid=202108&type_id=2001&state=1&keys=1&size=999&page=1', {}).then(
      //   res => {
      //     console.log(res);
      //     this.list1 = []
      //     this.list1 = res.data.data.data[0].models
      //     // console.log(this.list1);
      //     this.moreShowBoolen = false
      //   })
    },
    moreShow1 () { // 点击查询更多
      this.list_t2 += this.list_t2;
      if (this.list_t2 > this.list2_db_t) {
        this.moreShowBoolen2 = false
      }
      // this.$api.getAPI('mutual/server/?appid=202108&type_id=2001&state=1&keys=2&size=999&page=1', {}).then(
      //   res => {
      //     this.list2 = []
      //     this.list2 = res.data.data.data[0].models
      //     this.moreShowBoolen2 = false
      //   })

    },
    moreShow2 () { // 点击查询更多
      this.list_t3 += this.list_t3;
      if (this.list_t3 > this.list3_db_t) {
        this.moreShowBoolen3 = false
      }
      // this.$api.getAPI('mutual/server/?appid=202108&type_id=2001&state=1&keys=3&size=999&page=1', {}).then(
      //   res => {
      //     this.list3 = []
      //     // console.log(res.data.data[0].models);
      //     this.list3 = res.data.data.data[0].models
      //     // console.log(this.list3);
      //     this.moreShowBoolen3 = false
      //   })
    },
    bug () {
      this.$api.getAPI("mutual/server/?state=1&page=1", {
        appid: 202108,
        type_id: 2001,
        size: 200,
        keys: 1,
      }).then(res => {
        this.list1 = res.data.data.data[0].models;
        this.list1_db_t = res.data.data.data[0].page.count;
        this.moreShowBoolen = true
        // console.log(res.data.data[0].models);
        // if (res.data.data.data[0].models.length === 8) {
        //   this.list1 = res.data.data.data[0].models
        //   this.moreShowBoolen = true
        // } else {
        //   this.list1 = res.data.data.data[0].models.slice(0, 8)
        //   this.moreShowBoolen = false
        // }
        // console.log(this.list1);
        // this.bug1()
      })
    },
    bug1 () {
      this.$api.getAPI("mutual/server/?state=1&page=1", {
        appid: 202108,
        type_id: 2001,
        size: 200,
        keys: 2,
      }).then(res => {
        // console.log(res.data.data[0].models);
        this.list2 = res.data.data.data[0].models
        this.list2_db_t = res.data.data.data[0].page.count;
        this.moreShowBoolen2 = true
        // if (res.data.data.data[0].models.length === 8) {
        //   console.log(res);
        //   this.list2 = res.data.data.data[0].models
        //   this.moreShowBoolen2 = true
        // } else {
        //   this.list2 = res.data.data.data[0].models.slice(0, 8)
        //   this.moreShowBoolen2 = false
        // }
        //this.bug2()
      })
    },
    bug2 () {
      this.$api.getAPI("mutual/server/?state=1&page=1", {
        appid: 202108,
        type_id: 2001,
        size: 200,
        keys: 3,
      }).then(
        res => {
          this.list3 = res.data.data.data[0].models
          this.list3_db_t = res.data.data.data[0].page.count;
          this.moreShowBoolen3 = true
          // // console.log(res.data.data[0].models);
          // if (res.data.data.data[0].models.length === 8) {
          //   this.list3 = res.data.data.data[0].models
          //   this.moreShowBoolen3 = true
          // } else {
          //   this.list3 = res.data.data.data[0].models.slice(0, 8)
          //   this.moreShowBoolen3 = false
          // }
        })
    }
  },
  mounted () {
    this.bug()
    this.bug1()
    this.bug2()
    // console.log(this.list1);
    // console.log(this.list2);
    // console.log(this.list3);
  }
}
</script>

<style>
.t_10_t {
  margin-right: 1px;
  background: #f3f4f8;
  border: 1px solid #ccc !important;
}

.t_10 {
  padding-right: 15px;
}

.rom {
  border: 1px solid #ccc !important;
}

.container-fluid-server {
  padding-right: 7.5px;
}

.btn2 {
  border: none;
  outline: 0;
  background: none;
  /* background: #00a4b7bf;
  color: #fff;
  padding: 4px 5px 3px;
  font-size: 75%;
  font-weight: 700; */
}
</style>



// WEBPACK FOOTER //
// src/components/views/home_server.vue